import React from 'react';
import { Card, CardActionArea, CardActions, CardContent, CardMedia, Button, Typography, Grid } from '@mui/material';
import { useState, useRef } from 'react';



const products = [
    {
        id: 1,
        name: 'Product 1',
        description: 'This is a description of product 1',
        image: 'https://via.placeholder.com/200x140',
    },
    {
        id: 2,
        name: 'Product 2',
        description: 'This is a description of product 2',
        image: 'https://via.placeholder.com/200x140',
    },
    {
        id: 3,
        name: 'Product 3',
        description: 'This is a description of product 3',
        image: 'https://via.placeholder.com/200x140',
    },
    {
        id: 4,
        name: 'Product 4',
        description: 'This is a description of product 4',
        image: 'https://via.placeholder.com/200x140',
    },
    {
        id: 5,
        name: 'Product 5',
        description: 'This is a description of product 5',
        image: 'https://via.placeholder.com/200x140',
    },
    {
        id: 6,
        name: 'Product 6',
        description: 'This is a description of product 6',
        image: 'https://via.placeholder.com/200x140',
    },
    {
        id: 7,
        name: 'Product 7',
        description: 'This is a description of product 7',
        image: 'https://via.placeholder.com/200x140',
    },
    {
        id: 8,
        name: 'Product 8',
        description: 'This is a description of product 8',
        image: 'https://via.placeholder.com/200x140',
    },
    {
        id: 9,
        name: 'Product 9',
        description: 'This is a description of product 9',
        image: 'https://via.placeholder.com/200x140',
    },
    {
        id: 10,
        name: 'Product 10',
        description: 'This is a description of product 10',
        image: 'https://via.placeholder.com/200x140',
    },
];

export default function Cards() {

    const [scrollLeft, setScrollLeft] = useState(0);
    const scrollRef = useRef(null);

    const handleScrollLeft = () => {
        setScrollLeft(scrollLeft - 200);
        scrollRef.current.scrollLeft -= 200;
    };

    const handleScrollRight = () => {
        setScrollLeft(scrollLeft + 200);
        scrollRef.current.scrollLeft += 200;
    };

    return (
        <div justifyContent="right" alignItems="right"
            style={{
                position: 'relative',
                margin: 0,
                justifyContent: 'right',
                width: '90vw',
                height: '150px',
            }}>
            <Grid justifyContent="right" alignItems="right"
                style={{
                    marign: 0,
                    justifyContent: 'center',
                    width: '90vw',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(10, 500px)',
                    gridGap: '10px',
                    overflowX: 'scroll',
                    scrollBehavior: 'smooth'
                }}
                container spacing={3} ref={scrollRef}>
                {products.map((product) => (
                    <Grid item key={product.id}>
                        <Card >
                            <CardActionArea>
                                <CardMedia image={product.image} title={product.name} />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="h2">
                                        {product.name}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        {product.description}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Learn More
                                </Button>
                                <Button size="small" color="primary">
                                    Add to Cart
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            {/* <Button onClick={handleScrollLeft}>{"<"}</Button>
            <Button onClick={handleScrollRight}>{">"}</Button> */}
        </div >
    );
}